import { WithFetchDatasByIdFromCMS } from 'modules/shared-cms/hocs';

import { QUERY } from './promo-query';
import { PromoLoader } from './promo-component-loader';
import { PromoProps } from './promo-type';

const enhancer = WithFetchDatasByIdFromCMS<PromoProps>(QUERY, PromoLoader, 'findPromoContent');
export default enhancer;
